<template>
  <div></div>
</template>

<script>
export default {
  name: "Init",
  methods: {
    isMobile() {
      return window.innerWidth < 770
    }
  },
  created() {
    if (
      this.isMobile() &&
      /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    ) {
      this.$router.push("/mobile-start")
    } else {
      this.$router.push("/tan")
    }
  }
}
</script>